import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ProductTemperatureDomesticStepConfig: StepConfig = {
    type: FormType.PRODUCT_TEMPERATURE_DOMESTIC
};
